import React from 'react';
import ReactDOM from "react-dom/client";
import './trusted-security-policies'
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';

if (process.env.REACT_APP_ENV === 'production') {
  Sentry.init({
    dsn: "https://b73835d40b204feda30b03191ee0cea1@o1114804.ingest.sentry.io/6360812",
    tracesSampleRate: 0.1,
  });
}

const MOUNT_NODE = document.getElementById("root");
ReactDOM.createRoot(MOUNT_NODE).render(
  <BrowserRouter>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
